import { Box, TableCell, TableRow, Typography, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { getLanguages } from 'state/reducers/content.reducers';
import { ILanguage } from 'constants/content.constants';
import { TextInputTableCell } from './TextInputTableCell';
import { ImageTableCell } from './ImageTableCell';
import { TableComponent } from 'components/TableComponent';
import _ from 'lodash';

interface IProps {
	section: any;
	tableHeaderItems: string[];
}

export const MultiLangTable = ({ section, tableHeaderItems }: IProps) => {
	const languages = useAppSelector(getLanguages);
	const textFieldGroupType = 'text';
	const theme = useTheme();

	return (
		<TableComponent tableHeaderItems={tableHeaderItems} styleObj={{ minWidth: 650 }}>
			{_.sortBy(section.fieldGroups, 'order')?.map((fieldGroup: any, index: number) => {
				return (
					<Box sx={{ display: 'contents' }} key={index}>
						{fieldGroup?.fieldGroupItems?.length && (
							<TableRow
								key={fieldGroup.id}
								sx={{
									'& td': {
										borderBottom: '1px solid',
										borderColor: theme.palette.root.divider,
										paddingBottom: 4,
									},
									'&:last-child td, &:last-child th': { border: 0, alignContent: 'baseline' },
								}}
							>
								<TableCell sx={{ width: '200px' }}>
									<Box
										sx={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
										}}
									>
										<Typography variant="body">{fieldGroup.displayTitle}</Typography>
										<Box sx={{ display: 'flex', flexDirection: 'column', gap: '35px' }}>
											{languages?.map((language: ILanguage, index: number) => {
												return (
													<Typography key={index} variant="body">
														{language.displayName}
													</Typography>
												);
											})}
										</Box>
									</Box>
								</TableCell>
								{_.sortBy(fieldGroup.fieldGroupItems, 'order')?.map((fieldGroupItem: any) => {
									if (fieldGroupItem.type === textFieldGroupType) {
										return <TextInputTableCell key={fieldGroupItem.id} item={fieldGroupItem} />;
									} else {
										return <ImageTableCell key={fieldGroupItem.id} item={fieldGroupItem} />;
									}
								})}
							</TableRow>
						)}
					</Box>
				);
			})}
		</TableComponent>
	);
};
